export const content = {
  'designer.enterprise-billing.contact-account-team-action':
    'Contact account team',
  'designer.enterprise-billing.contact-your-account-team-action':
    'Contact your account team',
  'designer.enterprise-billing.external-action-label':
    '{{label}} (opens in a new tab)',
  'designer.enterprise-billing.cancel-action': 'Cancel',
  'designer.enterprise-billing.limits.cms-item.title': 'CMS item limit reached',
  'designer.enterprise-billing.limits.cms-item.message':
    'You reached the limit of {{limit}} CMS items. Contact your account team to discuss your Site plan.',
  'designer.enterprise-billing.limits.cms-item-per-collection.message':
    'You reached the limit of {{limit}} CMS items in this Collection. Contact your account team to discuss your Site plan.',
  'designer.enterprise-billing.limits.ecommerce-item.title':
    'Ecommerce item limit reached',
  'designer.enterprise-billing.limits.ecommerce-item.message':
    'You reached the limit of {{limit}} Ecommerce items. Contact your account team to discuss your Site plan.',
  'designer.enterprise-billing.limits.collection.title':
    'Collection limit reached',
  'designer.enterprise-billing.limits.collection.message':
    'You reached the limit of {{limit}} Collections. Contact your account team to discuss your Site plan.',
  'designer.enterprise-billing.limits.page.title': 'Page limit reached',
  'designer.enterprise-billing.limits.page.message':
    'You reached the limit of {{limit}} pages. Contact your account team to discuss your Site plan.',
  'designer.enterprise-billing.limits.page-template.title':
    'Page template limit reached',
  'designer.enterprise-billing.limits.page-template.message':
    'You reached the limit of {{limit}} page templates. Contact your account team to discuss your Site plan.',
  'designer.enterprise-billing.limits.collection-field.title':
    'Collection field limit reached',
  'designer.enterprise-billing.limits.collection-field.message':
    'You reached the limit of {{limit}} Collection fields. Contact your account team to discuss your Site plan.',
  'designer.enterprise-billing.limits.reference-field.title':
    'Reference field limit reached',
  'designer.enterprise-billing.limits.reference-field.message':
    'You reached the limit of {{limit}} reference fields. Contact your account team to discuss your Site plan.',
  'designer.enterprise-billing.limits.cms-item.add-site-plan-message':
    'You reached the limit of {{limit}} CMS items. Add a Site plan to create more items.',
  'designer.enterprise-billing.limits.cms-item-per-collection.add-site-plan-message':
    'You reached the limit of {{limit}} CMS items in this Collection. Add a Site plan to create more items.',
  'designer.enterprise-billing.limits.cms-item.add-cms-items-message':
    'You reached the limit of {{limit}} CMS items. Add a CMS items add-on to this site to create more items.',
  'designer.enterprise-billing.limits.cms-item-per-collection.add-cms-items-message':
    'You reached the limit of {{limit}} CMS items in this Collection. Add a CMS items add-on to this site to create more items.',
  'designer.enterprise-billing.limits.collection.add-site-plan-message':
    'You reached the limit of {{limit}} Collections. Add a Site plan to create more Collections.',
  'designer.enterprise-billing.limits.collection-field.add-site-plan-message':
    'You reached the limit of {{limit}} Collection fields. Add a Site plan to create more Collection fields.',
  'designer.enterprise-billing.limits.reference-field.add-site-plan-message':
    'You reached the limit of {{limit}} reference fields. Add a Site plan to create more reference fields.',
  'designer.enterprise-billing.code-component.publish-body':
    "Code components won't be included when you publish. Publishing them requires a Premium Site plan or higher.",
  'designer.enterprise-billing.add-site-plan-action': 'Add a Site plan',
  'designer.enterprise-billing.add-cms-items-action': 'Add CMS items',
  'designer.enterprise-billing.code-component.add-site-plan-body':
    'Add a Site plan to access code components.',
  'designer.enterprise-billing.libraries.install-code-libraries-banner':
    'Installing and using code components requires a Premium Site plan or higher.',
  'designer.enterprise-billing.libraries.share-libraries-banner':
    "Sharing more Libraries isn't available on your current Workspace plan.",
} as const;
